import type {InnStepValues, PaymentDetailsValues, PersonalInfoStepValues} from 'features/registration';
import {revokePreviewUrl} from './helpers';
import type {RegistrationWizardState} from './useRegistrationWizardState';

/** Частичные обновления значений шагов и работа с фото документов. */
export const useRegistrationPatchers = (state: RegistrationWizardState) => {
	const {
		setDocumentsUpload,
		setForeignDocumentDetails,
		setInnError,
		setInnStep,
		setPassportDetails,
		setPaymentDetails,
		setPersonalInfo,
		setResidentCodeStep,
		setSnilsStep,
		setTaxIdentifierStep,
	} = state;

	const patchPersonalInfo = (patch: Partial<PersonalInfoStepValues>) => {
		setPersonalInfo((current) => ({...current, ...patch}));
	};

	const patchInnStep = (patch: Partial<InnStepValues>) => {
		setInnError(null);
		setInnStep((current) => ({...current, ...patch}));
	};

	const patchTaxIdentifierStep = (patch: Partial<typeof state.taxIdentifierStep>) => {
		setInnError(null);
		setTaxIdentifierStep((current) => ({...current, ...patch}));
	};

	const patchSnilsStep = (patch: Partial<typeof state.snilsStep>) => {
		setSnilsStep((current) => ({...current, ...patch}));
	};

	const patchResidentCodeStep = (patch: Partial<typeof state.residentCodeStep>) => {
		setResidentCodeStep((current) => ({...current, ...patch}));
	};

	const patchPassportDetails = (patch: Partial<typeof state.passportDetails>) => {
		setPassportDetails((current) => ({...current, ...patch}));
	};

	const patchForeignDocumentDetails = (patch: Partial<typeof state.foreignDocumentDetails>) => {
		setForeignDocumentDetails((current) => ({...current, ...patch}));
	};

	const setDocumentPhoto = (slotId: string, file: File) => {
		setDocumentsUpload((current) => {
			revokePreviewUrl(current.slots[slotId]?.previewUrl ?? null);

			return {
				...current,
				slots: {
					...current.slots,
					[slotId]: {
						photo: file,
						previewUrl: URL.createObjectURL(file),
					},
				},
			};
		});
	};

	const removeDocumentPhoto = (slotId: string) => {
		setDocumentsUpload((current) => {
			revokePreviewUrl(current.slots[slotId]?.previewUrl ?? null);

			return {
				...current,
				slots: {
					...current.slots,
					[slotId]: {photo: null, previewUrl: null},
				},
			};
		});
	};

	const patchPaymentDetails = (patch: Partial<PaymentDetailsValues>) => {
		setPaymentDetails((current) => ({...current, ...patch}));
	};

	const setResidenceAddress = (residenceAddress: string) => {
		setDocumentsUpload((current) => ({...current, residenceAddress}));
	};

	return {
		patchForeignDocumentDetails,
		patchInnStep,
		patchPassportDetails,
		patchPaymentDetails,
		patchPersonalInfo,
		patchResidentCodeStep,
		patchSnilsStep,
		patchTaxIdentifierStep,
		removeDocumentPhoto,
		setDocumentPhoto,
		setResidenceAddress,
	};
};

export type RegistrationPatchers = ReturnType<typeof useRegistrationPatchers>;
